import type { FunctionComponent, ReactElement } from 'react';

import styles from './option_description_component.module.css';

type OptionProps = {
  option?: {
    label?: string;
    value?: string;
    description?: string;
    suffix?: string | ReactElement;
  };
};

const Option: FunctionComponent<OptionProps> = ({ option = {} }) => (
  <div className={styles.root}>
    <span className={styles.text}>
      <span className={styles.label}>
        <span className={styles.highlight}>{option.label}</span>
        {option.description ? ': ' : ''}
      </span>
      <span className={styles.description}>{option.description}</span>
    </span>
    {option.suffix ? (
      <span className={styles.suffix}>{option.suffix}</span>
    ) : undefined}
  </div>
);

export default Option;
